/**
 * @file 积分不足弹窗 - 各 variant 的文案与按钮配置
 */

import type {PointsModalVariant} from './useModalVariant';

export interface VariantButtonConfig {
    key: string;
    label: string;
    type: 'primary' | 'default';
    action: 'membership' | 'points' | 'close';
}

export interface VariantConfig {
    title: string;
    description: string;
    /**
     * 埋点 pop_type，按按钮组合区分：
     * 0-联系制片人充值积分 1-开通会员&充值积分 2-升级会员&充值积分 3-仅充值积分
     */
    popType: number;
    buttons: VariantButtonConfig[];
}

export const VARIANT_CONFIG: Record<PointsModalVariant, VariantConfig> = {
    projectNonProducer: {
        title: '积分不足',
        description: '积分不足，联系制片人充值可获得更多积分',
        popType: 0,
        buttons: [{key: 'ok', label: '知道了', type: 'primary', action: 'close'}],
    },
    nonMember: {
        title: '积分不足',
        description: '积分不足，开通会员或充值可获得积分',
        popType: 1,
        buttons: [
            {key: 'subscribe', label: '开通会员', type: 'primary', action: 'membership'},
            {key: 'recharge', label: '充值积分', type: 'default', action: 'points'},
        ],
    },
    nonTopMember: {
        title: '积分不足',
        description: '积分不足，开通会员或充值可获得更多积分',
        popType: 2,
        buttons: [
            {key: 'upgrade', label: '升级会员', type: 'primary', action: 'membership'},
            {key: 'recharge', label: '充值积分', type: 'default', action: 'points'},
        ],
    },
    topMember: {
        title: '积分不足',
        description: '积分不足，充值可获得更多积分',
        popType: 3,
        buttons: [{key: 'recharge', label: '充值积分', type: 'primary', action: 'points'}],
    },
};
